(function() {
  if (window.LeonGroupifyVariants) return;

  function parseJson(id) {
    try {
      var el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  // Sortiert die Slider-Karten: verfuegbar zuerst, dann aufsteigend nach
  // Preis. Dieselbe Regel wie im Drawer.
  //
  // Muss ZWEIMAL laufen. Grund: Shopify liefert bei mehr als etwa 20
  // Lookups per all_products nicht fuer alle Handles ein Produkt. Fuer
  // diese rendert das Liquid optimistisch als verfuegbar, weil es den
  // echten Zustand nicht kennt. Erst hydratePendingCards holt ihn per
  // /products/{handle}.js nach und setzt is-oos. Lief die Sortierung nur
  // beim Init, standen genau diese ausverkauften Karten vorne.
  function sortSliderCards(viewport) {
    if (!viewport) return;
    var track = viewport.querySelector('.lgv__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.lgv__card'));
    if (cards.length <= 1) return;

    function parseCents(card) {
      var el = card.querySelector('.lgv__price');
      if (!el) return 0;
      // Noch nicht nachgeladene Preise ganz nach hinten innerhalb ihrer
      // Gruppe, damit ein Platzhalter nicht als 0 vorne einsortiert wird.
      if (el.getAttribute('data-lgv-price-pending') === 'true') return Number.MAX_SAFE_INTEGER;
      var txt = el.textContent.replace(/[€\s]/g, '').replace('.', '').replace(',', '.');
      return Math.round(parseFloat(txt) * 100) || 0;
    }

    // Stabil sortieren: bei gleichem Rang bleibt die Metafeld-Reihenfolge.
    // Array.sort ist in aktuellen Browsern stabil, der Index dient als
    // zusaetzliche Absicherung.
    var order = new Map();
    cards.forEach(function(c, i) { order.set(c, i); });

    cards.sort(function(a, b) {
      var aOos = a.classList.contains('is-oos') ? 1 : 0;
      var bOos = b.classList.contains('is-oos') ? 1 : 0;
      if (aOos !== bOos) return aOos - bOos;
      var d = parseCents(a) - parseCents(b);
      if (d !== 0) return d;
      return order.get(a) - order.get(b);
    });

    // Nichts anfassen, wenn die Reihenfolge schon stimmt. Verhindert einen
    // ueberfluessigen Reflow und ein Zurueckspringen der Scrollposition.
    var unveraendert = cards.every(function(c, i) { return order.get(c) === i; });
    if (unveraendert) return;

    var frag = document.createDocumentFragment();
    cards.forEach(function(c) { frag.appendChild(c); });
    track.appendChild(frag);

    // Nach dem Umsortieren an den Anfang. Die Scrollposition zu erhalten
    // waere schlechter: an derselben Pixelposition stehen danach andere
    // Karten, der Nutzer sieht also einen Sprung ohne erkennbaren Grund.
    // Das Nachladen ist ohnehin rund eine Sekunde nach dem Seitenaufbau
    // fertig, der Slider steht dann praktisch immer noch am Anfang.
    viewport.scrollLeft = 0;
    if (typeof viewport._lgvScheduleUpdate === 'function') viewport._lgvScheduleUpdate();
  }

  function bindSlider(root, uid) {
    var viewport = document.getElementById('lgv-viewport-' + uid);
    var prevBtn = document.getElementById('lgv-prev-' + uid);
    var nextBtn = document.getElementById('lgv-next-' + uid);
    var progress = document.getElementById('lgv-progress-' + uid);
    var rafId = null;
    var resizeTimer = null;

    if (!viewport || !progress || viewport.dataset.lgvInit) return;

    function updateUi() {
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      var visibleRatio = viewport.scrollWidth > 0 ? Math.min(1, viewport.clientWidth / viewport.scrollWidth) : 1;
      var trackWidth = progress.parentElement ? progress.parentElement.clientWidth : viewport.clientWidth;
      var progressWidth = trackWidth * visibleRatio;
      var desktop = window.innerWidth > 749;

      progress.style.width = progressWidth + 'px';
      progress.style.transform = 'translateX(' + (ratio * Math.max(0, trackWidth - progressWidth)) + 'px)';

      if (prevBtn) {
        var prevDisabled = viewport.scrollLeft <= 4;
        prevBtn.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
        prevBtn.tabIndex = prevDisabled ? -1 : 0;
        prevBtn.hidden = !desktop || maxScroll <= 4 || prevDisabled;
      }

      if (nextBtn) {
        var nextDisabled = viewport.scrollLeft >= maxScroll - 4;
        nextBtn.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
        nextBtn.tabIndex = nextDisabled ? -1 : 0;
        nextBtn.hidden = !desktop || maxScroll <= 4 || nextDisabled;
      }
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(function() {
        rafId = null;
        updateUi();
      });
    }

    function scrollBy(dir) {
      viewport.scrollBy({ left: Math.round(viewport.clientWidth * 0.82) * dir, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (prevBtn.getAttribute('aria-disabled') !== 'true') scrollBy(-1);
      });
      prevBtn.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && prevBtn.getAttribute('aria-disabled') !== 'true') {
          e.preventDefault();
          scrollBy(-1);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (nextBtn.getAttribute('aria-disabled') !== 'true') scrollBy(1);
      });
      nextBtn.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && nextBtn.getAttribute('aria-disabled') !== 'true') {
          e.preventDefault();
          scrollBy(1);
        }
      });
    }

    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleUpdate, 100);
    });

    viewport.dataset.lgvInit = '1';

    // Damit die Sortierung nach dem Nachladen der Verfügbarkeiten erneut
    // laufen kann, wird der UI-Refresh am Element hinterlegt. Ohne das
    // bliebe nach einem Umsortieren die Fortschrittsleiste und der
    // Zustand der Pfeile auf dem alten Stand.
    viewport._lgvScheduleUpdate = scheduleUpdate;

    sortSliderCards(viewport);

    if (typeof IntersectionObserver !== 'undefined') {
      var fired = false;
      var io = new IntersectionObserver(function(entries, observer) {
        if (entries[0].isIntersecting && !fired) {
          fired = true;
          observer.disconnect();
          updateUi();
        }
      }, { rootMargin: '200px' });
      io.observe(root);
      var rect = root.getBoundingClientRect();
      if (rect.top < window.innerHeight + 200 && !fired) {
        fired = true;
        updateUi();
      }
    } else {
      updateUi();
    }
  }

  // Formatiert einen Cent-Betrag im Shopify-Format (€19,70)
  function formatMoney(cents) {
    if (!cents) return '';
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Extrahiert den Produkt-Handle aus einer /products/... URL
  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function buildRowsHtml(items, t) {
    // Sortiere: verfügbar zuerst, dann nach Preis (0 ans Ende)
    items.sort(function(a, b) {
      if (a.available !== b.available) return a.available ? -1 : 1;
      if (!a.price && b.price) return 1;
      if (a.price && !b.price) return -1;
      return a.price - b.price;
    });

    return items.map(function(item, idx) {
      var oos = !item.available;
      var rowCls = oos ? ' lgv-row-oos' : '';
      var handle = handleFromUrl(item.url);
      var thumb = item.image
        ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="80" height="80">'
        : '';
      var badge = oos
        ? '<span class="lgv-d-badge lgv-d-badge--oos"><span class="lgv-d-dot"></span>' + t.unavailable + '</span>'
        : '<span class="lgv-d-badge lgv-d-badge--avail"><span class="lgv-d-dot"></span>' + t.available + '</span>';

      // Preis: Wenn 0 oder fehlt → Placeholder der per JS befüllt wird
      var priceHtml = (item.price && item.price > 0)
        ? (item.price_formatted || formatMoney(item.price))
        : '<span class="lgv-price-loading" data-handle="' + (handle || '') + '">–</span>';

      var priceAttr = (item.price && item.price > 0) ? ' data-price="' + item.price + '"' : '';
      return '<tr class="lgv-d-row' + rowCls + '"' + priceAttr + ' data-href="' + (item.url || '') + '" tabindex="0" role="link">'
        + '<td class="lgv-d-td lgv-d-td--thumb"><div class="lgv-d-thumb"><div class="lgv-d-thumb-img">' + thumb + '</div></div></td>'
        + '<td class="lgv-d-td lgv-d-td--title">'
        + (item.vendor ? '<p class="lgv-d-vendor">' + item.vendor + '</p>' : '')
        + '<p class="lgv-d-title">' + (item.title || '') + '</p>'
        + '</td>'
        + '<td class="lgv-d-td lgv-d-td--price">' + priceHtml + '</td>'
        + '<td class="lgv-d-td lgv-d-td--avail">' + badge + '</td>'
        + '<td class="lgv-d-td lgv-d-td--action">'
        + '<a href="' + (item.url || '#') + '" class="lgv-d-view-btn" tabindex="-1" aria-hidden="true">'
        + '<svg viewBox="0 0 24 24" width="12" height="12" stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>'
        + '<span class="lgv-d-view-label">' + t.view_product + '</span>'
        + '</a></td>'
        + '</tr>';
    }).join('');
  }

  // Globaler Preis-Cache: verhindert Re-Fetches wenn Drawer erneut geöffnet wird
  // Key: product handle → { price, formatted, available }
  var lgvPriceCache = {};

  // Lädt Preise per /products/{handle}.js mit:
  // - Globalem Cache (kein doppelter Request für gleichen Handle)
  // - Max 4 parallele Requests (verhindert Server-Überlastung bei 20+ Items)
  function fetchMissingPrices(drawerId, t) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;
    var placeholders = drawer.querySelectorAll('.lgv-price-loading[data-handle]');
    if (!placeholders.length) return;

    // Gruppiere Placeholders nach Handle
    var byHandle = {};
    placeholders.forEach(function(el) {
      var h = el.getAttribute('data-handle');
      if (!h) return;
      if (!byHandle[h]) byHandle[h] = [];
      byHandle[h].push(el);
    });

    // Sortiert die Drawer-Tabelle nach: available zuerst, dann Preis aufsteigend
    function resortTbody() {
      var tbody = drawer.querySelector('tbody');
      if (!tbody) return;
      var rows = Array.from(tbody.querySelectorAll('tr.lgv-d-row'));
      rows.sort(function(a, b) {
        var aOos = a.classList.contains('lgv-row-oos') ? 1 : 0;
        var bOos = b.classList.contains('lgv-row-oos') ? 1 : 0;
        if (aOos !== bOos) return aOos - bOos;
        // Preis aus data-price Attribut (wird unten gesetzt) oder 0
        var aPrice = parseInt(a.getAttribute('data-price') || '0', 10);
        var bPrice = parseInt(b.getAttribute('data-price') || '0', 10);
        return aPrice - bPrice;
      });
      var frag = document.createDocumentFragment();
      rows.forEach(function(r) { frag.appendChild(r); });
      tbody.appendChild(frag);
    }

    function applyPrice(handle, data) {
      var price = data ? (data.price_min || data.price || 0) : 0;
      var formatted = price ? formatMoney(price) : '–';
      var available = data ? data.available : null;
      lgvPriceCache[handle] = { price: price, formatted: formatted, available: available };
      (byHandle[handle] || []).forEach(function(el) {
        el.textContent = formatted;
        el.classList.remove('lgv-price-loading');
        var row = el.closest('tr.lgv-d-row');
        if (row) {
          // Speichere Preis in Cents als data-Attribut für die Sortierung
          if (price) row.setAttribute('data-price', price);
          if (available === false) {
            row.classList.add('lgv-row-oos');
          } else if (available === true) {
            row.classList.remove('lgv-row-oos');
          }
          // Badge-HTML aktualisieren wenn available sich vom Liquid-Default unterscheidet
          if (available !== null) {
            var badgeCell = row.querySelector('.lgv-d-td--avail');
            if (badgeCell) {
              if (available === true && badgeCell.querySelector('.lgv-d-badge--oos')) {
                badgeCell.innerHTML = '<span class="lgv-d-badge lgv-d-badge--avail"><span class="lgv-d-dot"></span>' + t.available + '</span>';
              } else if (available === false && badgeCell.querySelector('.lgv-d-badge--avail')) {
                badgeCell.innerHTML = '<span class="lgv-d-badge lgv-d-badge--oos"><span class="lgv-d-dot"></span>' + t.unavailable + '</span>';
              }
            }
          }
        }
      });
    }

    // Wende Cache-Treffer sofort an, sammle offene Handles
    var pending = [];
    Object.keys(byHandle).forEach(function(handle) {
      if (lgvPriceCache[handle]) {
        applyPrice(handle, lgvPriceCache[handle]);
      } else {
        pending.push(handle);
      }
    });

    if (!pending.length) return;

    // Lade in Batches von max 4 concurrent Requests
    var CONCURRENCY = 4;
    var idx = 0;
    function next() {
      if (idx >= pending.length) return;
      var handle = pending[idx++];
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) { applyPrice(handle, data); next(); })
        .catch(function() { applyPrice(handle, null); next(); });
    }
    // Zähle abgeschlossene Requests und sortiere nach dem letzten
    var completed = 0;
    var total = pending.length;
    var origNext = next;
    next = function() {
      completed++;
      if (completed === total) resortTbody();
      origNext();
    };
    // Starte initial CONCURRENCY viele Requests parallel
    for (var i = 0; i < Math.min(CONCURRENCY, pending.length); i++) { origNext(); }
  }

  function buildDrawerCss(drawerId, uid) {
    return [
      '#' + drawerId + ' *{box-sizing:border-box;}',
      '#' + drawerId + ' #lgv-d-body-' + uid + '{border-top:1px solid rgba(0,0,0,.08);}',
      '#' + drawerId + ' .lgv-tbl{width:100%;border-collapse:collapse;table-layout:fixed;}',
      '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(1){width:60px;}',
      '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(2){width:auto;}',
      '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(3){width:86px;}',
      '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(4){width:108px;}',
      '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(5){width:92px;}',
      '#' + drawerId + ' .lgv-tbl thead th{position:sticky;top:0;z-index:1;background:#f5f5f7;padding:9px 8px;font-size:10px;font-weight:600;color:#888;text-align:left;text-transform:uppercase;letter-spacing:.5px;border-top:none;border-bottom:1px solid rgba(0,0,0,.07);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}',
      '#' + drawerId + ' .lgv-tbl thead th:first-child{padding-left:12px;}',
      '#' + drawerId + ' .lgv-tbl thead th:last-child{text-align:right;padding-right:12px;}',
      '#' + drawerId + ' .lgv-d-row{border-bottom:1px solid rgba(0,0,0,.06);cursor:pointer;transition:background .15s;}',
      '#' + drawerId + ' .lgv-d-row:last-child{border-bottom:none;}',
      '#' + drawerId + ' .lgv-d-row:hover{background:rgba(0,0,0,.025);}',
      '#' + drawerId + ' .lgv-row-oos{opacity:.55;}',
      '#' + drawerId + ' .lgv-d-td{padding:11px 8px;vertical-align:middle;overflow:hidden;}',
      '#' + drawerId + ' .lgv-d-td:first-child{padding-left:12px;}',
      '#' + drawerId + ' .lgv-d-td:last-child{padding-right:12px;text-align:right;}',
      '#' + drawerId + ' .lgv-d-thumb{width:44px;height:44px;border-radius:6px;overflow:hidden;background:#f0f0f0;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '#' + drawerId + ' .lgv-d-thumb img{width:100%;height:100%;object-fit:contain;display:block;}',
      '#' + drawerId + ' .lgv-d-vendor{font-size:10px;color:#bbb;margin:0 0 2px;line-height:1;}',
      '#' + drawerId + ' .lgv-d-title{font-size:12.5px;font-weight:400;color:#1a1a1a;line-height:1.35;overflow-wrap:break-word;word-break:break-word;}',
      '#' + drawerId + ' .lgv-row-oos .lgv-d-title{color:#999;}',
      '#' + drawerId + ' .lgv-d-td--price{font-size:13px;font-weight:700;color:#111;white-space:nowrap;}',
      '#' + drawerId + ' .lgv-row-oos .lgv-d-td--price{color:#bbb;}',
      '#' + drawerId + ' .lgv-d-badge{display:inline-flex;align-items:center;gap:3px;font-size:10.5px;font-weight:500;padding:3px 7px;border-radius:999px;white-space:nowrap;}',
      '#' + drawerId + ' .lgv-d-badge--avail{background:rgba(34,197,94,.12);color:#16a34a;}',
      '#' + drawerId + ' .lgv-d-badge--oos{background:rgba(0,0,0,.07);color:#888;}',
      '#' + drawerId + ' .lgv-d-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0;}',
      '#' + drawerId + ' .lgv-d-badge--avail .lgv-d-dot{background:#22c55e;}',
      '#' + drawerId + ' .lgv-d-badge--oos .lgv-d-dot{background:#aaa;}',
      '#' + drawerId + ' .lgv-d-view-btn{display:inline-flex;align-items:center;gap:3px;font-size:11px;font-weight:600;color:#0171e2;background:rgba(1,113,226,.08);border:none;border-radius:6px;padding:5px 8px;cursor:pointer;text-decoration:none;white-space:nowrap;transition:background .15s;max-width:100%;}',
      '#' + drawerId + ' .lgv-d-view-btn:hover{background:rgba(1,113,226,.16);}',
      '@media(max-width:749px){'
        + '#' + drawerId + ' .lgv-tbl{width:calc(100% - 2px);margin:0 0 0 1px;}'
        + '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(1){width:58px;}'
        + '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(2){width:100%;}'
        + '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(3){width:68px;}'
        + '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(4){width:0;display:none;}'
        + '#' + drawerId + ' .lgv-tbl colgroup col:nth-child(5){width:44px;}'
        + '#' + drawerId + ' .lgv-tbl thead th:nth-child(4){display:none;}'
        + '#' + drawerId + ' .lgv-d-td:nth-child(4){display:none;}'
        + '#' + drawerId + ' .lgv-d-view-label{display:none;}'
        + '#' + drawerId + ' .lgv-d-view-btn{padding:0;border-radius:50%;width:32px;height:32px;justify-content:center;flex-shrink:0;}'
        + '#' + drawerId + ' .lgv-d-td{padding:9px 6px;vertical-align:middle;}'
        + '#' + drawerId + ' .lgv-d-td:first-child{padding-left:14px;}'
        + '#' + drawerId + ' .lgv-d-td:last-child{padding-right:6px;}'
        + '#' + drawerId + ' .lgv-d-thumb{width:40px;height:40px;}'
        + '#' + drawerId + ' .lgv-d-title{font-size:12px;}'
        + '#' + drawerId + ' thead th{padding:8px 6px;}'
        + '#' + drawerId + ' thead th:first-child{padding-left:14px;}'
        + '#' + drawerId + ' thead th:last-child{padding-right:6px;}'
      + '}'
    ].join('');
  }

  function initDrawer(root, uid, t) {
    var trigger = document.getElementById('lgv-ov-trigger-' + uid);
    if (!trigger || trigger.dataset.lgvDrawerInit) return;

    var drawer = null;
    var overlay = null;
    var drawerBuilt = false;
    var DRAWER_ID = 'lgv-drawer-' + uid;
    var OVERLAY_ID = 'lgv-overlay-' + uid;

    function buildDrawer() {
      if (drawerBuilt) return;
      drawerBuilt = true;

      var data = parseJson('lgv-data-' + uid);
      var rowsHtml = buildRowsHtml((data.items || []).slice(), t);
      var isMobile = window.innerWidth <= 749;

      overlay = document.createElement('div');
      overlay.id = OVERLAY_ID;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'lgv-d-overlay';
      overlay.style.cssText = [
        'position:fixed','inset:0','background:rgba(0,0,0,0.42)',
        'z-index:9000','opacity:0','visibility:hidden',
        'transition:opacity .32s cubic-bezier(.4,0,.2,1),visibility .32s cubic-bezier(.4,0,.2,1)',
        '-webkit-backdrop-filter:blur(2px)','backdrop-filter:blur(2px)'
      ].join(';');

      drawer = document.createElement('aside');
      drawer.id = DRAWER_ID;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-labelledby', 'lgv-d-title-' + uid);
      drawer.style.cssText = isMobile ? [
        'position:fixed',
        'top:8px','bottom:8px','left:8px','right:8px',
        'width:calc(100vw - 16px)',
        'height:calc(100dvh - 16px)',
        'max-height:calc(100dvh - 16px)',
        'background:#fff',
        'z-index:9001','display:flex','flex-direction:column',
        'transform:translateY(calc(100vh + 20px))',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'border-radius:16px',
        'overflow:hidden','font-family:"DM Sans",sans-serif',
        'box-shadow:0 4px 32px rgba(0,0,0,0.22)'
      ].join(';') : [
        'position:fixed','top:0','right:0','bottom:0',
        'width:min(480px,100vw)','background:#fff',
        'z-index:9001','display:flex','flex-direction:column',
        'transform:translateX(100%)',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'overflow:hidden','font-family:"DM Sans",sans-serif',
        'box-shadow:-4px 0 24px rgba(0,0,0,0.12)'
      ].join(';');

      drawer.innerHTML = [
        '<div style="display:flex;justify-content:center;padding:10px 0 0;flex-shrink:0;"><div style="width:36px;height:4px;background:rgba(0,0,0,0.15);border-radius:99px;"></div></div>',
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:14px 20px 14px;flex-shrink:0;">',
          '<h2 id="lgv-d-title-' + uid + '" style="margin:0;font-size:16px;font-weight:600;color:#1a1a1a;letter-spacing:-0.3px;font-family:inherit;">' + ((data.label || '') + '') + '</h2>',
          '<button id="lgv-d-close-' + uid + '" type="button" aria-label="' + t.close_btn + '" style="display:flex!important;align-items:center!important;justify-content:center!important;width:32px!important;min-width:32px!important;max-width:32px!important;height:32px!important;min-height:32px!important;max-height:32px!important;border:none!important;background:rgba(0,0,0,0.06)!important;border-radius:50%!important;cursor:pointer!important;color:#555!important;transition:background .18s!important;flex-shrink:0!important;padding:0!important;box-sizing:content-box!important;appearance:none!important;-webkit-appearance:none!important;box-shadow:none!important;">',
            '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
        '</div>',
        '<div id="lgv-d-body-' + uid + '" style="flex:1;overflow-y:auto;overscroll-behavior:contain;padding:0;">',
          '<style>' + buildDrawerCss(DRAWER_ID, uid) + '</style>',
          '<table class="lgv-tbl"><colgroup><col><col><col><col><col></colgroup>',
          '<thead><tr><th style="width:60px;" aria-label="Bild"></th><th>' + t.col_variant + '</th><th style="white-space:nowrap;">' + t.col_price + '</th><th style="white-space:nowrap;">' + t.col_avail + '</th><th></th></tr></thead>',
          '<tbody id="lgv-d-tbody-' + uid + '">' + rowsHtml + '</tbody></table>',
        '</div>'
      ].join('');

      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      // Preise nachladen für Items die im Liquid-Cache nicht verfügbar waren
      fetchMissingPrices(DRAWER_ID, t);

      var tbody = document.getElementById('lgv-d-tbody-' + uid);
      if (tbody) {
        tbody.querySelectorAll('tr[data-href]').forEach(function(row) {
          function go() {
            var href = row.getAttribute('data-href');
            if (href) window.location.href = href;
          }
          row.addEventListener('click', function(e) {
            if (e.target.closest('a')) return;
            go();
          });
          row.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              go();
            }
          });
        });
      }

      var closeBtn = document.getElementById('lgv-d-close-' + uid);
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
        closeBtn.addEventListener('mouseover', function() {
          closeBtn.style.setProperty('background', 'rgba(0,0,0,.12)', 'important');
        });
        closeBtn.addEventListener('mouseout', function() {
          closeBtn.style.setProperty('background', 'rgba(0,0,0,.06)', 'important');
        });
      }

      overlay.addEventListener('click', closeDrawer);

      drawer.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(drawer.querySelectorAll('button:not([disabled]),[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      });
    }

    function openDrawer() {
      buildDrawer();
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.pointerEvents = 'auto';
      overlay.setAttribute('aria-hidden', 'false');
      drawer.style.setProperty('transform', 'none', 'important');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        var cb = document.getElementById('lgv-d-close-' + uid);
        if (cb) cb.focus();
      }, 360);
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      drawer.style.setProperty('transform', window.innerWidth <= 749 ? 'translateY(calc(100vh + 20px))' : 'translateX(100%)', 'important');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      trigger.focus();
    }

    // FIX: -webkit-line-clamp Hit-Test Bug (Chrome/WebKit)
    // Der Titellink <a> im <h3> hat visuell 2 Zeilen (39px), aber sein
    // Hit-Test-Bereich erstreckt sich auf die volle scrollHeight (58px+).
    // Das überdeckt den Button darunter vollständig.
    // Lösung: pointer-events:none auf den h3-Link; click-delegation auf dem
    // h3 selbst navigiert weiterhin zur Produktseite.
    var card = trigger.closest('.leon-product-card');
    if (card) {
      var titleLink = card.querySelector('.leon-product-card__body h3 a');
      var cardBody = card.querySelector('.leon-product-card__body');
      if (titleLink) {
        // Link-Hit-Test deaktivieren (webkit-line-clamp Bug: der Link-Klickbereich
        // ist größer als der sichtbare Text und würde den Button blockieren)
        titleLink.style.pointerEvents = 'none';
      }
      // Den gesamten Card-Body klickbar machen (ersetzt den natürlichen Link-Klickbereich).
      // So ist die Karte überall klickbar – konsistent mit Karten ohne Varianten-Trigger.
      if (cardBody && !cardBody.dataset.lgvNavInit) {
        cardBody.dataset.lgvNavInit = '1';
        cardBody.style.cursor = 'pointer';
        cardBody.addEventListener('click', function(e) {
          // Klicks auf interaktive Elemente nicht abfangen:
          // Drawer-Button, ATC-Button, Links (Rating, Lieferzeit etc.)
          if (e.target.closest('[data-lgv-drawer-root]')) return;
          if (e.target.closest('a[href]')) return;
          if (e.target.closest('button:not(.leon-variant-badge--trigger)')) return;
          if (e.target.closest('input, select, form')) return;
          var href = titleLink ? titleLink.getAttribute('href') : null;
          if (href) window.location.href = href;
        });
      }
    }

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });

    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });

    trigger.dataset.lgvDrawerInit = '1';
  }

  function init(root) {
    if (!root || root.dataset.lgvBooted) return;
    root.dataset.lgvBooted = '1';

    var uid = root.getAttribute('data-lgv-uid');
    var t = parseJson('lgv-locale-' + uid);
    t.overview_btn = t.overview_btn || 'Übersicht';
    t.close_btn = t.close_btn || 'Schließen';
    t.col_variant = t.col_variant || 'Variante';
    t.col_price = t.col_price || 'Preis';
    t.col_avail = t.col_avail || 'Verfügbarkeit';
    t.available = t.available || 'Auf Lager';
    t.unavailable = t.unavailable || 'Nicht verfügbar';
    t.view_product = t.view_product || 'Ansehen';

    var btnLabel = document.getElementById('lgv-ov-btn-label-' + uid);
    if (btnLabel) btnLabel.textContent = t.overview_btn;

    if (root.hasAttribute('data-lgv-root')) {
      bindSlider(root, uid);
      // BUG-FIX (Shopify all_products 20-Item-Limit-Leak):
      // Karten ohne validen Lookup haben `data-lgv-price-pending="true"`.
      // Wir laden ihre Preise/Verfügbarkeit per /products/{handle}.js nach.
      // Nutzt denselben lgvPriceCache wie der Drawer – kein doppelter Fetch.
      hydratePendingCards(root);
    }
    initDrawer(root, uid, t);
  }

  // Lädt Preise für Cards mit data-lgv-price-pending (Leak-Detection im Liquid).
  // Verwendet denselben Cache wie Drawer für minimale Network-Calls.
  function hydratePendingCards(root) {
    var pendingPrices = root.querySelectorAll('.lgv__price[data-lgv-price-pending="true"]');
    if (!pendingPrices.length) return;

    // Sammle alle pending Cards group-by handle
    var byHandle = {};
    pendingPrices.forEach(function(priceEl) {
      var card = priceEl.closest('.lgv__card');
      if (!card) return;
      var handle = card.getAttribute('data-lgv-handle');
      if (!handle) return;
      if (!byHandle[handle]) byHandle[handle] = [];
      byHandle[handle].push(card);
    });

    function applyToCard(card, data) {
      var priceEl = card.querySelector('.lgv__price');
      if (!priceEl) return;
      if (!data) {
        // Network-Fehler: zeige neutralen Platzhalter, kein Preis
        priceEl.removeAttribute('data-lgv-price-pending');
        return;
      }
      var price = data.price || data.price_min || 0;
      if (price) {
        priceEl.textContent = formatMoney(price);
      }
      priceEl.removeAttribute('data-lgv-price-pending');

      // Vendor nachfüllen, falls leer
      var vendorEl = card.querySelector('.lgv__vendor');
      if (vendorEl && !vendorEl.textContent.trim() && data.vendor) {
        vendorEl.textContent = data.vendor;
      }

      // OOS-Status: Wenn nicht verfügbar, Karte als OOS markieren.
      //
      // Frueher blieben diese Karten bewusst an ihrer Position, um kein
      // Umsortieren nach dem Laden auszuloesen. Das fuehrte aber dazu,
      // dass ausverkaufte Varianten vorne standen – die Karten aus dem
      // all_products-Leak werden vom Liquid als verfuegbar gerendert und
      // landeten damit in der vorderen Gruppe. Deshalb wird nach dem
      // Nachladen jetzt neu sortiert (siehe sortAfterHydrate unten).
      if (data.available === false) {
        card.classList.add('is-oos');
        var oosLabel = (card.querySelector('.lgv__item-title') || {}).textContent || '';
        card.setAttribute('aria-label', oosLabel + ' (nicht verfügbar)');
      }
    }

    // Nach Abschluss aller Nachladungen einmal neu sortieren, damit die
    // inzwischen als ausverkauft erkannten Karten nach hinten wandern.
    // Einmal am Ende statt nach jeder Antwort – sonst springt die Reihe
    // bei jedem eintreffenden Request.
    var viewport = root.querySelector('.lgv__viewport');
    function sortAfterHydrate() {
      sortSliderCards(viewport);
    }

    // Max 4 concurrent Requests
    var pending = [];
    Object.keys(byHandle).forEach(function(handle) {
      if (lgvPriceCache[handle]) {
        var cached = lgvPriceCache[handle];
        byHandle[handle].forEach(function(card) {
          applyToCard(card, { price: cached.price, available: cached.available });
        });
      } else {
        pending.push(handle);
      }
    });

    if (!pending.length) {
      // Alles kam aus dem Cache: direkt sortieren.
      sortAfterHydrate();
      return;
    }

    var CONCURRENCY = 4;
    var idx = 0;
    var offen = pending.length;

    function erledigt() {
      offen -= 1;
      if (offen <= 0) sortAfterHydrate();
    }

    function next() {
      if (idx >= pending.length) return;
      var handle = pending[idx++];
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (data) {
            lgvPriceCache[handle] = {
              price: data.price,
              formatted: formatMoney(data.price),
              available: data.available
            };
          }
          (byHandle[handle] || []).forEach(function(card) {
            applyToCard(card, data);
          });
          erledigt();
          next();
        })
        .catch(function() {
          (byHandle[handle] || []).forEach(function(card) {
            applyToCard(card, null);
          });
          erledigt();
          next();
        });
    }
    for (var i = 0; i < Math.min(CONCURRENCY, pending.length); i++) next();
  }

  function boot() {
    document.querySelectorAll('[data-lgv-root], [data-lgv-drawer-root]').forEach(init);
  }

  // FIX Bug 2: MutationObserver für per AJAX nachgeladene Produkte (Load-More)
  function observeNewProducts() {
    if (typeof MutationObserver === 'undefined') return;
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      var hasNewRoots = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.hasAttribute && (node.hasAttribute('data-lgv-drawer-root') || node.hasAttribute('data-lgv-root'))) ||
            (node.querySelector && node.querySelector('[data-lgv-drawer-root],[data-lgv-root]'))
          ) {
            hasNewRoots = true;
            break;
          }
        }
        if (hasNewRoots) break;
      }
      if (hasNewRoots) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(boot, 80);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      boot();
      observeNewProducts();
    });
  } else {
    boot();
    observeNewProducts();
  }
  document.addEventListener('shopify:section:load', boot);

  window.LeonGroupifyVariants = { boot: boot };
})();